var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftBlueArrow1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6886 5.55222C12.6333 5.54325 12.5774 5.53912 12.5215 5.53984H2.99752L3.20519 5.44325C3.40819 5.34717 3.59286 5.21641 3.75094 5.05689L6.4217 2.38612C6.77345 2.05034 6.83255 1.51019 6.56176 1.10628C6.2466 0.675874 5.64221 0.582422 5.21177 0.897582C5.177 0.923059 5.14394 0.950829 5.11288 0.980712L0.283293 5.8103C-0.0941391 6.18731 -0.0944712 6.79889 0.282539 7.17632C0.28278 7.17656 0.283052 7.17683 0.283293 7.17707L5.11288 12.0067C5.49062 12.3833 6.10219 12.3825 6.4789 12.0048C6.50854 11.975 6.53622 11.9434 6.56176 11.9101C6.83255 11.5062 6.77345 10.966 6.4217 10.6302L3.75577 7.95464C3.61405 7.81277 3.45111 7.69381 3.27281 7.60208L2.98303 7.47168H12.4683C12.9618 7.49 13.3947 7.14532 13.4874 6.66031C13.5728 6.13373 13.2152 5.63764 12.6886 5.55222Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBlueArrow1);
export default __webpack_public_path__ + "static/media/LeftBlueArrow1.afc3711b98a34743e96aaecaa67b1619.svg";
export { ForwardRef as ReactComponent };